import { render, staticRenderFns } from "./MobileNav.component.vue?vue&type=template&id=87db8f80&scoped=true&"
import script from "./MobileNav.component.vue?vue&type=script&lang=js&"
export * from "./MobileNav.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87db8f80",
  null
  
)

export default component.exports